var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1665 2.99993C14.3854 2.78106 14.6452 2.60744 14.9312 2.48899C15.2171 2.37054 15.5236 2.30957 15.8332 2.30957C16.1427 2.30957 16.4492 2.37054 16.7352 2.48899C17.0211 2.60744 17.281 2.78106 17.4998 2.99993C17.7187 3.2188 17.8923 3.47863 18.0108 3.7646C18.1292 4.05057 18.1902 4.35706 18.1902 4.66659C18.1902 4.97612 18.1292 5.28262 18.0108 5.56859C17.8923 5.85455 17.7187 6.11439 17.4998 6.33326L6.24984 17.5833L1.6665 18.8333L2.9165 14.2499L14.1665 2.99993Z",
    stroke: "#0074C0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.063e5ed69f3eaf2468e4c7d70506300e.svg";
export { ForwardRef as ReactComponent };